import { projectRepository } from '../repositories/projectRepository';
import { schemaValidator } from '../validators/schemaEngine';

export const ProjectService = {
  getProjectsList: async () => {
    return await projectRepository.getAll();
  },

  getProjectDetails: async (projectId) => {
    return await projectRepository.getById(projectId);
  },

  createProject: async (metadata) => {
    schemaValidator.validate('project', metadata);
    return await projectRepository.create({ metadata });
  },

  deleteProjectCascade: async (projectId) => {
    return await projectRepository.delete(projectId);
  },

  getActiveProjectId: async () => {
    return await projectRepository.getActiveProjectId();
  },

  setActiveProjectId: async (projectId) => {
    return await projectRepository.setActiveProjectId(projectId);
  }
};
